import { deserialize, deserializeAs } from 'libs/cerialize';

import { EntityPortlets } from 'Core/Portlets/Models/Design/Explorer/EntityPortlets';

export class PortletsCollection {
    @deserialize
    Entities: Array<EntityPortlets>;
}
